<template>
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 15a4 4 0 0 0 4-4V6a4 4 0 1 0-8 0v5a4 4 0 0 0 4 4z" />
    <path
      d="M19 11a7 7 0 0 1-14 0M12 18v3"
      stroke="currentColor"
      stroke-width="2"
      fill="none"
    />
  </svg>
</template>

<script>
export default { name: "IconMic" };
</script>
